import styled, { css } from 'styled-components';

export const ScrollContainer = styled.div`
  display: none;
  @media (${props => props.theme.breakpoint.md.up}) {
    display: flex;
    align-items: stretch;
    margin-right: 10px;
  }
`;

export const Container = styled.nav<{ $isHidden?: boolean }>`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
  transition: opacity 0.5s ease;
  ${props =>
    props.$isHidden === true &&
    css`
      opacity: 0;
    `};
  @media (${props => props.theme.breakpoint.lg.down}) {
    display: none;
  }

  > a,
  > button {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
`;
